import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {ClipboardService} from 'ngx-clipboard';
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'asax-header-share-container',
  templateUrl: './share-container.component.html',
  styles:
  [
    `.dropdown-toggle::after {
      display: none;
    }`
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShareContainerComponent {
  @ViewChild('tooltip', {static: false}) readonly tooltip: NgbTooltip;

  constructor(private readonly clipboardService: ClipboardService) {
  }

  openInNewTab(): void {
    const windowLocationHref = window.location.href;
    window.open(`${windowLocationHref}`, '_blank');
  }

  copyToClipboard(): void {
    const windowLocationHref = window.location.href;
    this.clipboardService.copy(`${windowLocationHref}`);
    this.displayTooltip();
  }

  displayTooltip(): void {
    this.tooltip?.open();
    setTimeout(() => this.tooltip?.close(), 500);
  }

  shareByEmail(): void {
    const windowLocationHref = window.location.href;
    window.location.href = `mailto:?subject=ALMA Archive link&body=${windowLocationHref}`;
  }
}
